import z from "zod"

export const ClarificationRequestsAPIType = "clarification_requests" as const
export const ClarificationRequestTypename = "ClarificationRequest" as const

export const clarificationRequestResourceTypeMap = {
  Project: "projects",
  Floor: "floors",
  Room: "rooms",
  ProductPosition: "project-positions"
} as const

export type ClarificationRequestResourceType =
  (typeof clarificationRequestResourceTypeMap)[keyof typeof clarificationRequestResourceTypeMap]

export const MAX_LENGTH_CLARIFICATION_REQUEST = 256

export const ClarificationRequestSchema = z.object({
  content: z.string().max(MAX_LENGTH_CLARIFICATION_REQUEST).nullish(),
  __typename: z
    .literal(ClarificationRequestTypename)
    .optional()
    .transform(() => ClarificationRequestTypename)
})
